export enum PaymentWalletType {
  PHONE = 'phone',
  EMAIL = 'email',
  WALLET = 'wallet',
  DEFAULT = 'default',
}
